import { createMuiTheme, colors } from "@material-ui/core";
//import { THEMES } from 'src/constants';
import { softShadows } from "./shadows";
import typography from "./typography";

const theme = createMuiTheme({
  direction: "ltr",
  typography,
  baseOptions: {
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: "hidden",
      },
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32,
      },
    },
    MuiChip: {
      root: {
        backgroundColor: "rgba(0,0,0,0.075)",
      },
    },
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        borderColor: colors.blueGrey[50],
      },
      notchedOutline: {
        borderColor: colors.blueGrey[600],
      },
    },
    MuiDivider: {
      root: {
        color: colors.blueGrey[50],
        backgroundColor: colors.blueGrey[50],
      },
    },
    MuiInputBase: {
      input: {
        "&::placeholder": {
          opacity: 1,
          color: colors.blueGrey[600],
        },
      },
    },
  },
  palette: {
    type: "dark",
    action: {
      // active: 'rgba(255, 255, 255, 0.54)',
      // hover: 'rgba(255, 255, 255, 0.04)',
      // selected: 'rgba(255, 255, 255, 0.08)',
      disabled: "rgba(255, 255, 255, 0.26)",
      // disabledBackground: 'rgba(255, 255, 255, 0.12)',
      // focus: 'rgba(255, 255, 255, 0.12)',
      active: colors.blueGrey[600],
    },
    background: {
      default: colors.common.white,
      dark: "#f8f4f4",
      paper: colors.common.white,
    },
    primary: {
      main: colors.red[600],
      gray: "#f8f4f4",
    },
    secondary: {
      main: "#ff1744",
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600],
    },
  },
  shadows: softShadows,
});

export default theme;

// Real dark colors

// palette: {
//   type: 'dark',
//   action: {
//     active: 'rgba(255, 255, 255, 0.54)',
//     hover: 'rgba(255, 255, 255, 0.04)',
//     selected: 'rgba(255, 255, 255, 0.08)',
//     disabled: 'rgba(255, 255, 255, 0.26)',
//     disabledBackground: 'rgba(255, 255, 255, 0.12)',
//     focus: 'rgba(255, 255, 255, 0.12)'
//   },
//   background: {
//     default: '#282C34',
//     dark: '#1c2025',
//     paper: '#282C34'
//   },
//   primary: {
//     main: '#8a85ff'
//   },
//   secondary: {
//     main: '#8a85ff'
//   },
//   text: {
//     primary: '#e6e5e8',
//     secondary: '#adb0bb'
//   }
// },
